export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/el.lyaml"));
at({ "el": { "public": { "sampleString": "\u0394\u03B5\u03AF\u03B3\u03BC\u03B1 \u03C3\u03C5\u03BC\u03B2\u03BF\u03BB\u03BF\u03C3\u03B5\u03B9\u03C1\u03AC\u03C2" } } });
};